export default __webpack_public_path__ + "static/media/passivewave2d.131f0f32.png";